import EcoLink from 'eco-design/base/eco-link';
export default function FooterC1Share({ list = [] }: { list: any[] }) {
    return (
        <div className="icon-list">
            {list
                ?.slice?.() // 复制一份防止改变原数组
                .sort((a: any, b: any) => (a.sort ?? 0) - (b.sort ?? 0))
                .map((item) => {
                    const obj = JSON.parse(item.content) as any;
                    return (
                        <EcoLink
                            className="icon"
                            key={item.type}
                            href={obj.redirectUrl}
                            target="_blank"
                            dataLayer={{
                                event: 'uaEvent',
                                event_name: 'ecoflow_social',
                                button_name: obj.redirectUrl,
                            }}
                        >
                            <img className="icon-img icon-img-default" src={obj.iconUrl} />
                            <img className="icon-img icon-img-hover" src={obj.hoverIconUrl} />
                        </EcoLink>
                    );
                })}
        </div>
    );
}
